import itemCard from '../str-item-card/item-card';

export default itemCard;
